/**
 * WhatsApp exclusive badge (snippets/eg-whatsapp-badge.liquid) — lets Escape
 * hide an open hover/focus tooltip without moving the pointer or focus
 * (WCAG 1.4.13 "dismissible"). The tooltip itself is pure CSS; it shows again
 * once the pointer or focus re-enters the badge.
 *
 * Document-level listeners, so badges that arrive later (async product
 * recommendations, variant morphs) are covered without any setup.
 */
(function () {
  const BADGE = '.eg-whatsapp-badge';
  const DISMISSED = 'data-tooltip-dismissed';

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    // `:focus` rather than `:focus-visible`: same effect here, and no selector error in older Safari
    for (const badge of document.querySelectorAll(`${BADGE}:hover, ${BADGE}:focus`)) {
      badge.setAttribute(DISMISSED, '');
    }
  });

  /**
   * Re-arms a dismissed tooltip when the pointer or focus enters its badge from outside.
   * @param {PointerEvent | FocusEvent} event
   */
  const rearm = (event) => {
    if (!(event.target instanceof Element)) return;

    const badge = event.target.closest(BADGE);
    if (!badge || !badge.hasAttribute(DISMISSED)) return;
    if (event.relatedTarget instanceof Node && badge.contains(event.relatedTarget)) return;

    badge.removeAttribute(DISMISSED);
  };

  document.addEventListener('pointerover', rearm);
  document.addEventListener('focusin', rearm);
})();
